module.exports = __webpack_public_path__ + "img/show 8@2x.63a42beb.png";